import { loc } from "../i18n/survey";
import { locIconButton } from "./utils";

enum TypeofSupport {
  Onlyaworkout = 'Only a workout and nutrition tracking tool',
  Personalized = 'Personalized workout and nutrition coaching',
  Both =  '⁠Both a tracker and coaching',
  Other = 'Other',
}

const typeofsupportQuestion = {
  name: 'typeofsupport',
  title: loc("quiz.typeofsupport.title"),
  description: loc("quiz.typeofsupport.description"),
  type: 'radiogroup',
  choices: [
    {
      value: TypeofSupport.Onlyaworkout,
      text: locIconButton("quiz.typeofsupport.choices.tracking", "📊"),
    },
    {
      value: TypeofSupport.Personalized,
      text: locIconButton("quiz.typeofsupport.choices.guidance", "🧑‍🏫"),
    },
    {
      value: TypeofSupport.Both,
      text: locIconButton("quiz.typeofsupport.choices.both", "🤝"),
    },
  ],
  isRequired: true,
};

export {
  TypeofSupport,
  typeofsupportQuestion,
};